import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FunctionsService } from '../../../___LOGIC/__common/functions.service';
import { DynamicCrudService } from 'src/app/___LOGIC/__crud/dynamic-crud.service';

@Component({
  selector: 'app-dynamic-timestamp-picker',
  templateUrl: './dynamic-timestamp-picker.component.html',
  styleUrls: ['./dynamic-timestamp-picker.component.css']
})
export class DynamicTimestampPickerComponent implements OnInit {

  @Input() data;
  @Output() public dataOut = new EventEmitter();
  selectedDate;
  selectedTime;
  timestamp: number | null = null;
  shortDate;
  inputValue; // needed to change selection format 
  editMode = false;

  times = Array.from({ length: 24 }, (_, i) => `${i}:00`); // Generates ["0:00", "1:00", ..., "23:00"]

  constructor(private dynamicCrudService: DynamicCrudService, private commonFunctions: FunctionsService) { }

  ngOnInit(): void {
  }

  generateTimestamp(): void {
    if (this.selectedDate && this.selectedTime) {
      const [hours, minutes] = this.selectedTime.split(':').map(Number);
      const date = new Date(this.selectedDate);
      date.setHours(hours, minutes, 0, 0); // Set time

      this.timestamp = date.getTime(); // Get timestamp
      console.log('Generated Timestamp:', this.timestamp);
    }
  }

  switchEditingMode(){
    this.editMode = !this.editMode;
    this.editMode? this.dynamicCrudService.setCurrentFieldToEdit(this.data.columnName): null;
  }

  isEditMode(){
    return this.editMode && this.dynamicCrudService.isCurrentFieldEditing(this.data.columnName);
  }
  onDateChange(e){
    this.selectedDate = e.target.value;
    if (this.selectedDate && this.selectedTime){
      this.switchEditingMode();
      this.generateTimestamp();
      this.data.value = this.timestamp;
      this.dataOut.emit(this.data);
    }
  }
  updateTimeSelection(time){
    this.selectedTime =  time;
    /* this.dataOut.emit(this.data); */
    if (this.selectedDate && this.selectedTime){
      this.switchEditingMode();
      this.generateTimestamp();
      this.data.value = this.timestamp;
      this.dataOut.emit(this.data);
    }
  }

  isDateEmpty(){
    return this.commonFunctions.isDateEmpty(this.data.selectedDate);
  }

  getDateToRender(){
    if(this.dynamicCrudService.getCurrentStatus() == 'update'){
      if(this.commonFunctions.isDateEmpty(this.data.value)){
        this.shortDate = '0000-00-00';
      }else{
        const parsedDate = new Date(this.data.value);
        // Check if the parsed date is invalid
        if (isNaN(parsedDate.getTime())) {
          this.shortDate = ''; // Return empty string for invalid dates
        } else {
          this.shortDate = parsedDate.toLocaleDateString('en-GB'); // Convert valid date
        }
        return this.shortDate;
      }
    }else{
      return this.shortDate;
    }
  }

}
